export default "/images/smartphone.svg?c98e345c042d5a4d2ec2d61b307258cd";